<script setup lang="ts">
import type { IApiMediaWithCrops } from "~/models/generated/IApiMediaWithCrops";

const props = defineProps<{
  heading: string | null;
  image: IApiMediaWithCrops[] | null;
}>();

const hasContent = computed( () => {
  return props.heading || props.image;
} );
</script>

<template>
  <div
    v-if="hasContent"
    class="page-heading">
    <div class="container">
      <h1>{{ heading }}</h1>
    </div>

    <template v-if="image?.[0]">
      <div class="page-heading__gradient" />
      <img
        :src="image[0].url + '?width=500&height=225'"
        :srcset="image[0].url + '?width=500&height=225 1x, ' + image[0].url + '?width=1000&height=450 2x'"
        class="page-heading__image"
        alt="Page heading background image">
    </template>
  </div>
</template>

<style scoped lang="scss">
.page-heading {
  max-width: 1300px;
  min-height: 225px;
  background-color: var(--color-accent-1);
  overflow: hidden;
  position: relative;
  padding: 50px 0;
  display: flex;
  align-items: center;
  margin: 0 auto 30px;

  @media ( max-width: 768px ) {
    height: auto;
    padding: 25px 0;
  }

  .container {
    z-index: 2;
    width: 100%;
  }

  &__gradient {
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient( 90deg, var( --color-accent-1 ) 65%, color-mix( in srgb, var(--color-accent-1) 50%, transparent ) 100% );
  }

  &__image {
    position: absolute;
    right: 0;
  }

  h1 {
    color: #fff;
    font-size: 4rem;

    @media ( max-width: 768px ) {
      font-size: 2rem;
    }
  }
}
</style>
